import { checkNull, ReportContainer } from "../constant";
import { ALLERGY_SECTION } from "../../utils/subjective-entry";
import EntryLines from "./EntryLines";

interface AllergiesBlockProps {
  data: any;
}

const AllergiesBlock = ({ data }: AllergiesBlockProps) => {
  if (!checkNull(data?.patientAllergies)) return null;

  return (
    <ReportContainer label="Allergies">
      <EntryLines section={ALLERGY_SECTION} rows={data?.patientAllergies} />
    </ReportContainer>
  );
};

export default AllergiesBlock;
